export default __webpack_public_path__ + "static/media/ImageArchitect1.032614a5.png";